import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { ADMIN_API_BASE_URL, ADMIN_API_WS_URL, MAIN_APP_URL, PUBLIC_API_ORIGIN } from './app.tokens';
import { AdminConfigService } from './services/admin-config.service';
import { adminAuthInterceptor } from './interceptors/admin-auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([adminAuthInterceptor])
    ),
    {
      provide: MAIN_APP_URL,
      useValue: environment.mainAppUrl
    },
    {
      provide: PUBLIC_API_ORIGIN,
      useValue: environment.publicApiOrigin
    },
    {
      provide: ADMIN_API_BASE_URL,
      useFactory: () => {
        const configService = inject(AdminConfigService);
        configService.loadFromStorage();
        return configService.baseUrl();
      }
    },
    {
      provide: ADMIN_API_WS_URL,
      useFactory: () => {
        const configService = inject(AdminConfigService);
        configService.loadFromStorage();
        return configService.wsUrl();
      }
    }
  ]
};
